export default {"src":"https://fishbrain.com/_next/static/media/kentucky.26715ef4.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};